import { RavelElement } from '../../../base/ravel-element/src/RavelElement.js';
import globalStyles from '../../../../common/global-styles.js';
import { ravelComponentPath } from '../../../../common/RavelComponentPath.js';

export class RavelBlockly extends RavelElement {

    static get observedAttributes() { 
        return [...super.baseObservedAttributes, 
            'signals', 'signal-out'];
    }

    constructor() {
        super();
        this.initialize();
    }

    initialize() {
        this._workspace = null;
        this._container = null;
        this._resizeObserver = null;
        this.signals = [];
    }

    connectedCallback() {
        this.observedMessages = [`${this.id}`];
        this.subscribe(this.observedMessages);
        this.subscribe(this.signals);  

        // Avoid re-init if reconnected
        if (this._workspace) return;

        // Make sure the host can size itself
        if (!this.style.display) {
            this.style.display = 'block';
            this.style.width = '100%';
            this.style.height = '100%';
        }
        if (!this.style.position) {
            this.style.position = 'relative';
        }

        // Create the div that Blockly will own
        const container = document.createElement('div');
        container.className = 'ravel-blockly-container';
        Object.assign(container.style, {
            position: 'absolute',
            inset: '0',        // top:0; right:0; bottom:0; left:0

        });

        this.appendChild(container);
        this._container = container;

        // Build a simple no-category, horizontal, bottom toolbox
        const toolbox = this._buildToolbox();

        this._workspace = Blockly.inject(container, {
            toolbox,
            theme: Blockly.Themes.Zelos,
            renderer: 'zelos',
            horizontalLayout: true,
            toolboxPosition: 'end',
            scrollbars: false,
            trashcan: false
        });

        // Keep Blockly SVG in sync with element size
        this._resizeObserver = new ResizeObserver(() => {
        if (this._workspace) {
            Blockly.svgResize(this._workspace);
        }
        });
        this._resizeObserver.observe(this);
    }

    disconnectedCallback() {
        if (this._resizeObserver) {
        this._resizeObserver.disconnect();
        this._resizeObserver = null;
        }
        if (this._workspace) {
        this._workspace.dispose();
        this._workspace = null;
        }
        this._container = null;
        // Optionally clear children:
        // this.innerHTML = '';
    }

    _buildToolbox() {
        // Flat “continuous” toolbox, horizontal at bottom
        return {
            kind: 'flyoutToolbox',
            contents: [
                { kind: 'block', type: 'controls_if' },
                { kind: 'block', type: 'logic_compare' },
                { kind: 'block', type: 'math_number' },
                { kind: 'block', type: 'text' },
                { kind: 'block', type: 'text_print' },
                // Add your music / custom blocks here
            ],
        };
    }

  // --- Public API helpers ---

  /** Get underlying Blockly workspace */
  get workspace() {
    return this._workspace;
  }

  /** Example: generate JS code (requires javascript generator scripts) */
  getCode() {
    if (!this._workspace || !Blockly.JavaScript) return '';
    return Blockly.JavaScript.workspaceToCode(this._workspace);
  }

  /** Clear workspace programmatically */
  clear() {
    if (this._workspace) {
      this._workspace.clear();
    }
  }

    attributeChangedCallback(name, oldValue, newValue) {
        // Call the parent's attributeChangedCallback to preserve its behavior
        super.attributeChangedCallback(name, oldValue, newValue);
    }
}
